import { render, staticRenderFns } from "./LotsPanel.vue?vue&type=template&id=27ea5b3c"
import script from "./LotsPanel.vue?vue&type=script&lang=js"
export * from "./LotsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports